import script from "./WageEmployeeCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageEmployeeCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./WageEmployeeCalendar.vue?vue&type=style&index=0&id=9af3bfdc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9af3bfdc"]])

export default __exports__